import { Injectable } from '@angular/core';
import { Router } from '@angular/router';
import { Http, Headers, Response, RequestOptions } from '@angular/http';
import { Observable } from 'rxjs/Observable';
import { ErrorObservable } from 'rxjs/observable/ErrorObservable';
import { BehaviorSubject } from 'rxjs/BehaviorSubject';

import { User } from '../../models/user';
import { Session } from '../../models/session';
import { GenericdatasetSettings } from '../genericdataset/genericdataset.settings';
import { ProfileService } from '../profile/profile.service';
import { PlatformService } from '../platform/platform.service';
import { UserService } from '../user/user.service';

declare const $: any;

@Injectable()
export class SessionService {
  public loggedIn: boolean = false;
  public currentSession: Session = new Session();
  public _session: BehaviorSubject<Session> = new BehaviorSubject(new Session());
  public session: Observable<Session> = this._session.asObservable();
  public headers = new Headers({ 'Content-Type': 'application/json' });
  public options = new RequestOptions({ headers: this.headers });

  constructor(
    public platform: PlatformService,
    public user: UserService,
    public router: Router,
    public http: Http) {
    if (this.platform.isBrowser) {
      let token = localStorage.getItem('token');
      if (token) this.currentSession.token = token;
      if (this.currentSession.token) {
        this.getToken(this.currentSession.token)
          .subscribe(
          (result) => {
            if (!result.error) {
              if (result.data.logged) {
                this.currentSession.users.firstname = result.data.user.firstname;
                this.currentSession.users.lastname = result.data.user.lastname;
                this.currentSession.users.email = result.data.user.email;
                this.currentSession.users.id = result.data.user.id;
                this.currentSession.users.profile = result.data.user.profile;
                this.loggedIn = true;
                setTimeout(() => $(".button-collapse").sideNav(), 2000);
                this._session.next(this.currentSession);
              } else {
                if (this.currentSession.token !== result.data.token) {
                  this.currentSession.token = result.data.token;
                  localStorage.setItem('token', this.currentSession.token);
                  this._session.next(this.currentSession);
                } else {
                  this._session.next(this.currentSession);
                }
              }
            }
          },
          (error) => {
            console.log(error);
          });
      } else {
        this.getToken()
          .subscribe(
          (result) => {
            if (!result.error) {
              this.currentSession.token = result.data.token;
              localStorage.setItem('token', this.currentSession.token);
              this._session.next(this.currentSession);
            }
          },
          (error) => {
            console.log(error);
          });
      }
    }
  }

  public isLoggedIn(): boolean {
    return this.loggedIn;
  }

  public setLoggedIn(loggedIn: boolean) {
    this.loggedIn = loggedIn;
  }

  public getLanguage(): string {
    return this.currentSession.users.language;
  }

  public setLanguage(language: string) {
    this.currentSession.users.language = language;
    //this.translate.use(language);
    //this.session.language_id = language;
    //this.updateSession(this.session).subscribe(session => {}, error => {});
  }

  public setSkin(skin: string) {
    this.currentSession.users.skin = skin;
    this.updateSession(this.currentSession).subscribe((session) => { }, (error) => { });
  }

  public setProfile(profile: string) {
    this.currentSession.users.profile = profile;
    this.user.updateProfile(this.currentSession.users).subscribe((user) => { console.log(user); }, (error) => { console.log(error); });
  }

  public logout() {
    this.currentSession.users = new User();
    this.setLoggedIn(false);
    this.router.navigate(['']);
  }

  public getToken(accessToken?: string): Observable<any> {
    let tokenUrl = GenericdatasetSettings.api_endpoint + 'token';
    if (accessToken) {
      tokenUrl = tokenUrl + '?access_token=' + accessToken;
    }
    return this.http.get(tokenUrl, this.options)
      .map(this.extractData)
      .catch(this.handleError);
  }

  public addSession(item: any): Observable<any> {
    const sessionUrl = GenericdatasetSettings.api_endpoint + 'sessions';
    const body = JSON.stringify(item);
    return this.http.post(sessionUrl, body, this.options)
      .map(this.extractData)
      .catch(this.handleError);
  }

  public updateSession(item: any): Observable<any> {
    const sessionUrl = GenericdatasetSettings.api_endpoint + 'sessions/' + item.id;
    const body = JSON.stringify(item);
    return this.http.put(sessionUrl, body, this.options)
      .map(this.extractData)
      .catch(this.handleError);
  }

  public getSessionByToken(token: string): Observable<any> {
    const sessionUrl = GenericdatasetSettings.api_endpoint + 'sessions?filter[where][token]=' + token + '&filter[include]=users';
    return this.http.get(sessionUrl, this.options)
      .map(this.extractData)
      .catch(this.handleError);
  }

  public extractData(res: Response) {
    const body = res.json();
    return body;
  }

  public handleError(error: any) {
    const errMsg = (error.message) ? error.message :
      error.status ? `${error.status} - ${error.statusText}` : 'Server error';
    return Observable.throw(errMsg);
  }

}
